import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    api_url : process.env.VUE_APP_API_URL || 'https://livesocialfeed.com/api',
    base_url :  process.env.VUE_APP_BASE_URL || 'https://livesocialfeed.com',
    loading : false,
    user : JSON.parse(localStorage.getItem('user')) || null,
  },
  getters: {
  },
  mutations: {
    setLoading (state, value) {
      state.loading = value
    },
    setUser(state, user) {
      localStorage.setItem('user', JSON.stringify(user));
      state.user = user;
    }
  },
  actions: {
  },
  modules: {
  }
})
